var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"DmhConfirm"}},[(_vm.question.question_type === 'text')?_c('p',{staticClass:"brand-text dmh-confirm-text",class:[_vm.isWhiteSpacePreWrap ? 'pre-wrap' : 'custom-space'],domProps:{"innerHTML":_vm._s(_vm.question.sub_text)}}):_c('img',{staticClass:"img-fluid",attrs:{"src":"/img/dmh/map.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }